(function () {
  var icon = document.getElementById('cart-icon');
  if (!icon) return;

  document.addEventListener('on:cart:add', function () {
    icon.classList.remove('js-cart-add');
    void icon.offsetWidth; // restart animation if triggered again quickly
    icon.classList.add('js-cart-add');
  });

  icon.addEventListener('animationend', function () {
    icon.classList.remove('js-cart-add');
  });

  // UPSELL HOOK — fire your upsell here when ready:
  // document.addEventListener('on:cart:add', function (e) {
  //   document.dispatchEvent(new CustomEvent('pp:show-upsell', { detail: e.detail }));
  // });
})();
